import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { getFirstTermDebtLabel } from "../../utils/utils";

const DeleteAccountantDialog = ({ open, onClose, onConfirm, deletingData, classTitle, isLoading }) => {
  const handleConfirm = () => {
    if (onConfirm && deletingData) {
      onConfirm();
    }
  };

  // Format currency values for display
  const formatCurrency = (value) => {
    if (value === null || value === undefined) return "0";
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          <Typography variant="h6">Confirm Delete</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone. The accountant record will be permanently deleted.
        </Alert>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this accountant record?
        </Typography>
        {deletingData && deletingData.originalData && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              <strong>Term:</strong> {deletingData.termName || deletingData.originalData?.term?.termName || deletingData.originalData?.termName || "N/A"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              <strong>{getFirstTermDebtLabel(classTitle)}:</strong> {formatCurrency(deletingData.originalData?.firstTermDebt || 0)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>2nd Term Debt:</strong> {formatCurrency(deletingData.originalData?.secondTermDebt || 0)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>1st Term Fee:</strong> {formatCurrency(deletingData.originalData?.firstTermFee || 0)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>2nd Term Fee:</strong> {formatCurrency(deletingData.originalData?.secondTermFee || 0)}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountantDialog;

